<ng-container *ngIf="mobile; else deskTemplate">
  <app-m-home></app-m-home>
</ng-container>
<ng-template #deskTemplate>
  <app-home></app-home>
  <!-- <app-recommendations></app-recommendations> -->
  <!-- <app-technologies></app-technologies> -->
</ng-template>